<template>
  <LcCard v-bind="cardProps" header-class="flex items-center justify-between">
    <template #header>
      <h2 class="paragraph-bold">{{ headline }}</h2>
      <LcSwitch v-model:value="isCollapsed" />
    </template>

    <template v-if="!isCollapsed" #default>
      <slot />
    </template>
  </LcCard>
</template>

<script lang="ts" setup>
import type { LcCardProps } from '@lottocom/frontend-components'

type PickLotteryQuickPickCardProps = Pick<LcCardProps, 'bodyClass'> & {
  headline: string
}

const { headline, ...cardProps } = defineProps<PickLotteryQuickPickCardProps>()

const isCollapsed = defineModel('collapsed', {
  default: true,
  type: Boolean,
})
</script>
